import * as React from "react";
const SvgLounge = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.723 5.46A1.778 1.778 0 0 0 3.225 4.16a2.12 2.12 0 0 0-1.218 2.128l.69 7.118a3.736 3.736 0 0 0 1.419 2.59l-1.072 3.001a.75.75 0 0 0 1.412.505l1.012-2.832c.487.13 1.008.162 1.54.08l3.365-.527 1.17 3.279a.75.75 0 0 0 1.413-.505l-1.147-3.21c.423-.323.69-.83.69-1.394v-1.463a2.75 2.75 0 0 0-2.987-2.74l-2.667.233a.25.25 0 0 1-.268-.205l-.854-4.76Zm-1.867.062a.278.278 0 0 1 .391.203l.854 4.759a1.75 1.75 0 0 0 1.874 1.434l2.667-.232A1.25 1.25 0 0 1 11 12.931v1.463a.25.25 0 0 1-.212.247l-4.011.627a2.25 2.25 0 0 1-2.587-2.006L3.5 6.144a.62.62 0 0 1 .356-.622ZM15.5 15.7a2.75 2.75 0 0 1-1.5-2.45v-.5a.75.75 0 0 1 .75-.75h2.75v-1.649l-1.23-1.024a.75.75 0 0 1 .48-1.326h3a.75.75 0 0 1 .48 1.326L19 10.351V12h2.25a.75.75 0 0 1 .75.75v.5a2.75 2.75 0 0 1-1.5 2.45v3.55a.75.75 0 0 1-1.5 0V16h-2v3.25a.75.75 0 0 1-1.5 0V15.7Zm1.25-1.2h2.5c.605 0 1.11-.43 1.225-1h-4.95c.116.57.62 1 1.225 1Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLounge;
